import {
    FETCH_DRIVER_BY_ID_REQUEST,
    FETCH_DRIVER_BY_ID_SUCCESS,
    FETCH_DRIVER_BY_ID_FAILURE,

    REGISTER_DRIVER_FOR_USER_REQUEST,
    REGISTER_DRIVER_FOR_USER_SUCCESS,
    REGISTER_DRIVER_FOR_USER_FAILURE,

    UPDATE_DRIVER_FOR_PARTNER_REQUEST,
    UPDATE_DRIVER_FOR_PARTNER_SUCCESS,
    UPDATE_DRIVER_FOR_PARTNER_FAILURE,

    REGISTER_VEHICLE_FOR_USER_REQUEST,
    REGISTER_VEHICLE_FOR_USER_SUCCESS,
    REGISTER_VEHICLE_FOR_USER_FAILURE,

    UPDATE_VEHICLE_FOR_PARTNER_REQUEST,
    UPDATE_VEHICLE_FOR_PARTNER_SUCCESS,
    UPDATE_VEHICLE_FOR_PARTNER_FAILURE,

    FETCH_RECRUITED_VEHICLES_REQUEST,
    FETCH_RECRUITED_VEHICLES_SUCCESS,
    FETCH_RECRUITED_VEHICLES_FAILURE,
} from "./types";

import {
    fetchDriverById,
    registerDriverForUser,
    updateDriverForPartner,
} from "../../services/driverService";

import {
    registerVehicleForUser,
    updateVehicleForPartner,
    fetchRecruitedVehicles,
} from "../../services/vehicleService";


export const fetchDriverByIdAction =
    (
        driverId
    ) =>
    async (
        dispatch
    ) => {

        dispatch({
            type:
                FETCH_DRIVER_BY_ID_REQUEST,
        });

        const result =
            await fetchDriverById(
                driverId
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    FETCH_DRIVER_BY_ID_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    FETCH_DRIVER_BY_ID_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };


export const registerDriverForUserAction =
    (
        userId,
        payload
    ) =>
    async (
        dispatch
    ) => {

        dispatch({
            type:
                REGISTER_DRIVER_FOR_USER_REQUEST,
        });

        const result =
            await registerDriverForUser(
                userId,
                payload
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    REGISTER_DRIVER_FOR_USER_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    REGISTER_DRIVER_FOR_USER_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };


export const updateDriverForPartnerAction =
    (
        driverId,
        payload
    ) =>
    async (
        dispatch
    ) => {

        dispatch({
            type:
                UPDATE_DRIVER_FOR_PARTNER_REQUEST,
        });

        const result =
            await updateDriverForPartner(
                driverId,
                payload
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    UPDATE_DRIVER_FOR_PARTNER_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    UPDATE_DRIVER_FOR_PARTNER_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };


export const registerVehicleForUserAction =
    (
        userId,
        payload
    ) =>
    async (
        dispatch
    ) => {

        dispatch({
            type:
                REGISTER_VEHICLE_FOR_USER_REQUEST,
        });

        const result =
            await registerVehicleForUser(
                userId,
                payload
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    REGISTER_VEHICLE_FOR_USER_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    REGISTER_VEHICLE_FOR_USER_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };


export const updateVehicleForPartnerAction =
    (
        vehicleId,
        payload
    ) =>
    async (
        dispatch
    ) => {

        dispatch({
            type:
                UPDATE_VEHICLE_FOR_PARTNER_REQUEST,
        });

        const result =
            await updateVehicleForPartner(
                vehicleId,
                payload
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    UPDATE_VEHICLE_FOR_PARTNER_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    UPDATE_VEHICLE_FOR_PARTNER_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };


export const fetchRecruitedVehiclesAction =
    (
        page = 1,
        size = 10
    ) =>
    async (
        dispatch
    ) => {

        dispatch({
            type:
                FETCH_RECRUITED_VEHICLES_REQUEST,
        });

        const result =
            await fetchRecruitedVehicles(
                page,
                size
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    FETCH_RECRUITED_VEHICLES_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    FETCH_RECRUITED_VEHICLES_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };